/**
 * Defines the default TRL cursor CSS variables used across the framework.
 *
 * @type {{ [key: string]: string }}
 */
export const cursorCSSVariables = {
   '--tjs-cursor-all-scroll': 'all-scroll',
   '--tjs-cursor-all-scroll-down': 'all-scroll',

   '--tjs-cursor-alias': 'alias',
   '--tjs-cursor-alias-down': 'alias',

   '--tjs-cursor-cell': 'cell',
   '--tjs-cursor-cell-down': 'cell',

   '--tjs-cursor-copy': 'copy',
   '--tjs-cursor-copy-down': 'copy',

   '--tjs-cursor-context-menu': 'context-menu',
   '--tjs-cursor-context-menu-down': 'context-menu',

   '--tjs-cursor-crosshair': 'crosshair',
   '--tjs-cursor-crosshair-down': 'crosshair',

   '--tjs-cursor-default': 'default',
   '--tjs-cursor-default-down': 'default',

   '--tjs-cursor-grab': 'grab',
   '--tjs-cursor-grab-down': 'var(--tjs-cursor-grabbing, grabbing)',

   '--tjs-cursor-grabbing': 'grabbing',
   '--tjs-cursor-grabbing-down': 'grabbing',

   '--tjs-cursor-help': 'help',
   '--tjs-cursor-help-down': 'help',

   '--tjs-cursor-pointer': 'pointer',
   '--tjs-cursor-pointer-down': 'pointer',

   '--tjs-cursor-move': 'move',
   '--tjs-cursor-move-down': 'move',

   '--tjs-cursor-no-drop': 'no-drop',
   '--tjs-cursor-no-drop-down': 'no-drop',

   '--tjs-cursor-not-allowed': 'not-allowed',
   '--tjs-cursor-not-allowed-down': 'not-allowed',

   '--tjs-cursor-progress': 'progress',
   '--tjs-cursor-progress-down': 'progress',

   '--tjs-cursor-resize-col': 'col-resize',
   '--tjs-cursor-resize-col-down': 'col-resize',

   '--tjs-cursor-resize-e': 'e-resize',
   '--tjs-cursor-resize-e-down': 'e-resize',

   '--tjs-cursor-resize-ew': 'ew-resize',
   '--tjs-cursor-resize-ew-down': 'ew-resize',

   '--tjs-cursor-resize-n': 'n-resize',
   '--tjs-cursor-resize-n-down': 'n-resize',

   '--tjs-cursor-resize-ne': 'ne-resize',
   '--tjs-cursor-resize-ne-down': 'ne-resize',

   '--tjs-cursor-resize-nesw': 'nesw-resize',
   '--tjs-cursor-resize-nesw-down': 'nesw-resize',

   '--tjs-cursor-resize-ns': 'ns-resize',
   '--tjs-cursor-resize-ns-down': 'ns-resize',

   '--tjs-cursor-resize-nw': 'nw-resize',
   '--tjs-cursor-resize-nw-down': 'nw-resize',

   '--tjs-cursor-resize-nwse': 'nwse-resize',
   '--tjs-cursor-resize-nwse-down': 'nwse-resize',

   '--tjs-cursor-resize-row': 'row-resize',
   '--tjs-cursor-resize-row-down': 'row-resize',

   '--tjs-cursor-resize-s': 's-resize',
   '--tjs-cursor-resize-s-down': 's-resize',

   '--tjs-cursor-resize-se': 'se-resize',
   '--tjs-cursor-resize-se-down': 'se-resize',

   '--tjs-cursor-resize-sw': 'sw-resize',
   '--tjs-cursor-resize-sw-down': 'sw-resize',

   '--tjs-cursor-resize-w': 'w-resize',
   '--tjs-cursor-resize-w-down': 'w-resize',

   '--tjs-cursor-text': 'text',
   '--tjs-cursor-text-down': 'text',

   '--tjs-cursor-text-vertical': 'vertical-text',
   '--tjs-cursor-text-vertical-down': 'vertical-text',

   '--tjs-cursor-wait': 'wait',
   '--tjs-cursor-wait-down': 'wait',

   '--tjs-cursor-zoom-in': 'zoom-in',
   '--tjs-cursor-zoom-in-down': 'zoom-in',

   '--tjs-cursor-zoom-out': 'zoom-out',
   '--tjs-cursor-zoom-out-down': 'zoom-out',
};
